


























import {Component, Prop, Vue} from 'vue-property-decorator'


@Component({})
export default class RadioImageButton extends Vue {

    @Prop() private name!: string;
    @Prop() private radioItems!: CMS.RadioImageItem[];
    @Prop() private selectedItem!: string;
    private hash: string = Math.random().toString();

    get radioValue(): string {
        return this.selectedItem;
    }

    private onClick(value: string) {
        this.$emit("change", value)
    }
}
